// extracted by mini-css-extract-plugin
module.exports = {"title":"ArticleLikeDislike_title__DzOQ0","buttons":"ArticleLikeDislike_buttons__U1y2W","successIcon":"ArticleLikeDislike_successIcon__xcgYT"};